module.exports = __webpack_public_path__ + "img/logo.0ce5a52e.png";